import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotebookFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.33301 3.37769C3.32955 2.23681 5.98308 2.64439 7.6 3.28V14.05C5.7 13.2 3.46423 12.7977 1.33301 13.711V3.37769Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.6663 3.3777C12.6698 2.23682 10.0163 2.64439 8.4 3.28V14.05C10.3 13.2 12.5351 12.7977 14.6663 13.711V3.3777Z",
		fill: "#111827"
	})]
});
const ForwardRef = forwardRef(SvgNotebookFilled);
export default ForwardRef;
